import { useTranslation } from 'react-i18next'

import type { WalletBalanceOriginRow } from '../WalletBalanceOrigin/types'
import { WalletShorelineFilter } from './WalletShorelineFilter'

type WalletOriginFilterProps = {
  origins: WalletBalanceOriginRow[]
  value: string
  onChange: (checkingAccountId: string) => void
}

export const WalletOriginFilter = ({
  origins,
  value,
  onChange
}: WalletOriginFilterProps) => {
  const { t } = useTranslation()

  if (!origins.length) return null

  return (
    <WalletShorelineFilter
      label={t('rm:wallet.movimentations.filter.origin')}
      value={value}
      onChange={onChange}
      options={[
        { value: '', label: t('rm:wallet.movimentations.filter.origin.all') },
        ...origins.map(origin => ({
          value: origin.checkingAccountId,
          label:
            origin.kind === 'preexisting'
              ? t('rm:wallet.balanceOrigin.preexisting.name')
              : `${origin.name} · ${origin.id}`
        }))
      ]}
    />
  )
}
